import { render } from "./SimilarTitles.vue?vue&type=template&id=46c54eae"
import script from "./SimilarTitles.vue?vue&type=script&setup=true&lang=js"
export * from "./SimilarTitles.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/SimilarTitles.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46c54eae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46c54eae', __exports__)) {
    api.reload('46c54eae', __exports__)
  }
  
  module.hot.accept("./SimilarTitles.vue?vue&type=template&id=46c54eae", () => {
    api.rerender('46c54eae', render)
  })

}


export default __exports__